module.exports = __webpack_public_path__ + "static/media/Box.03d0737d.png";